import { FormattedMessage } from 'react-intl';
import { CloseIcon } from 'components/Icons';
import { commonTexts } from 'i18n';
import { Tooltip } from '@mui/material';
import { FilterBarProps } from './interfaces';
import {
  Container,
  TopChildrenHolder,
  FiltersContainer,
  RightChildrenHolder,
  ResetButton,
  ResetButtonSlot,
} from './FilterBar.styled';

function FilterBar({
  children,
  onClearFilters,
  showClearButton,
  topChildren,
  rightChildren,
  disableClearButton,
  sx,
  filtersSx,
  iconOnlyReset,
  reserveClearButtonSpace,
}: FilterBarProps) {
  const shouldRenderResetButton = showClearButton || reserveClearButtonSpace;
  const resetButton = (
    <ResetButton
      onClick={onClearFilters}
      disabled={disableClearButton || !showClearButton}
      startIcon={<CloseIcon />}
      iconOnlyReset={iconOnlyReset}
      sx={{
        visibility: showClearButton ? 'visible' : 'hidden',
        pointerEvents: showClearButton ? 'auto' : 'none',
      }}
    >
      {iconOnlyReset ? null : (
        <FormattedMessage {...commonTexts.resetAllFilters} />
      )}
    </ResetButton>
  );

  return (
    <Container sx={sx}>
      {topChildren ? (
        <TopChildrenHolder>{topChildren}</TopChildrenHolder>
      ) : null}
      <FiltersContainer sx={filtersSx}>
        {children}
        {shouldRenderResetButton && (
          <ResetButtonSlot iconOnlyReset={iconOnlyReset}>
            {showClearButton ? (
              <Tooltip
                title={
                  iconOnlyReset ? (
                    <FormattedMessage {...commonTexts.resetAllFilters} />
                  ) : null
                }
              >
                {resetButton}
              </Tooltip>
            ) : (
              resetButton
            )}
          </ResetButtonSlot>
        )}
        {rightChildren ? (
          <RightChildrenHolder>{rightChildren}</RightChildrenHolder>
        ) : null}
      </FiltersContainer>
    </Container>
  );
}

export default FilterBar;
